module.exports = __webpack_public_path__ + "img/frame (203).d3f2a007.jpg";